var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtlasLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.83916C5.49289 1.83916 1.83916 5.49289 1.83916 10C1.83916 14.5071 5.49289 18.1608 10 18.1608C14.5071 18.1608 18.1608 14.5071 18.1608 10C18.1608 5.49289 14.5071 1.83916 10 1.83916ZM1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10ZM10.335 7.33805C10.3174 7.31568 10.2972 7.29477 10.2745 7.27575C10.1961 7.20992 10.1006 7.17771 10.0056 7.17758C9.91006 7.17731 9.81389 7.20952 9.73496 7.27575C9.71228 7.29478 9.69212 7.3157 9.67452 7.33809L6.12337 11.5702C5.97442 11.7477 5.99757 12.0123 6.17509 12.1613C6.3526 12.3102 6.61725 12.2871 6.7662 12.1096L10.0048 8.25003L13.2433 12.1096C13.3922 12.2871 13.6569 12.3102 13.8344 12.1613C14.0119 12.0123 14.0351 11.7477 13.8861 11.5702L10.335 7.33805Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasLogo);
export default __webpack_public_path__ + "static/media/atlas-logo.b979aaa8.svg";
export { ForwardRef as ReactComponent };